export function clone<T extends object>(source: T): T {
  return JSON.parse(JSON.stringify(source)) as T
}
